import { Button, Form, Grid, Theme, Viewport } from '@livecontrol/core-ui';
import type { ScheduledEvent } from '../../graphql';
import { Preferences } from './preferences';

export const VideographerInfo = ({ scheduledEvent }: { scheduledEvent: ScheduledEvent }): React.ReactElement => {
    const viewport = Theme.useViewport();

    return (
    <Grid className='text-white mt-24px gap-16px'
    gridTemplateColumns={[Viewport.XL, Viewport.LG].includes(viewport) ? 'repeat(2, 1fr) min-content' : '1fr'}
    >
        <Grid.Item className='d-flex flex-column'>
            <div className="d-flex justify-content-between">
                <h1 className='text-white font-size-18px'>Event Notes</h1>
                {scheduledEvent.cue_sheet_url && (
                <Button
                variant='outline-light'
                className="mb-8px"
                href={scheduledEvent.cue_sheet_url}
                target='_blank'
                size='sm'
                style={{ direction: 'ltr' }}
                >
                <i className='far fa-external-link-alt mr-8px' />
                View Cue Sheet
                </Button>
            )}
            </div>
            <Form.Group
                name='operatorNotes'
                label={false}
                error={false}
                className='d-flex flex-column h-100'
                controlProps={{
                    as: 'textarea',
                    className: 'h-100',
                    value: scheduledEvent.operator_notes ?? '',
                    disabled: true,
                    style: { backgroundColor: 'var(--white10)' }
                }}
            />
        </Grid.Item>
        <Grid.Item className='d-flex flex-column'>
            <h1 className='text-white font-size-18px'>Permanent Notes</h1>
            <Form.Group
                name='permanentNotes'
                label={false}
                error={false}
                className='d-flex flex-column h-100'
                controlProps={{
                as: 'textarea',
                className: 'h-100',
                value: scheduledEvent.location?.user?.event_operator_notes ?? '',
                disabled: true,
                style: { backgroundColor: 'var(--white10)' }
                }}
            />
        </Grid.Item>
        <Grid.Item>
            <Preferences event={scheduledEvent} />
        </Grid.Item>
    </Grid>
);
};
